import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "@/app/routes";
import type { ChangeAddressConfirmState } from "./ChangeAddressConfirmPage";
import { ChangeAddressResult, ErrorWarningIcon } from "./ChangeAddressResult";
export default function ChangeAddressErrorPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as ChangeAddressConfirmState | null;

  return (
    <ChangeAddressResult
      screenTitle="เปลี่ยนที่อยู่จัดส่งเอกสาร"
      showHeader={false}
      icon={<ErrorWarningIcon />}
      status="พบข้อผิดพลาด"
      statusTone="error"
      heading="ทำรายการไม่สำเร็จ"
      actionLabel="ลองอีกครั้ง"
      onAction={() => {
        if (state === null) {
          void navigate(ROUTES.settings.accountDocumentAddress, {
            replace: true,
          });
          return;
        }
        const retryState: ChangeAddressConfirmState = { ...state, askPin: true };
        void navigate(ROUTES.settings.accountChangeAddressConfirm, {
          replace: true,
          state: retryState,
        });
      }}
      secondaryLabel="กลับสู่หน้าตั้งค่า"
      onSecondary={() => {
        void navigate(ROUTES.settings.account, { replace: true });
      }}
    />
  );
}
